import TrackCard from './TrackCard';

export default function PlaylistTrackGrid({
    tracks = [],
    onPlayTrack,
}) {
    return (
        <div className="bjnt-track-preview-grid">
            {tracks.map((track, index) => (
                <TrackCard
                    key={track.id}
                    track={track}
                    index={index}
                    onPlayTrack={onPlayTrack}
                />
            ))}
        </div>
    );
}